import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AdminHttpService } from './admin-http.service';
import { Observable, catchError, map, of, shareReplay } from 'rxjs';

export interface IAdminMe {
  person_id: number;
  email_address: string;
  first_name: string;
  last_name: string;
  org_id: number;
  role: string;
  is_admin: boolean;
}

export type AdminAccess = 'admin' | 'forbidden' | 'signed-out';

@Injectable({
  providedIn: 'root',
})
export class AdminSessionService {

  private _me$?: Observable<{ code: number; data?: IAdminMe }>;

  constructor(protected _http_service: AdminHttpService) {}

  // One backend check per full page load: the first call hits GET admin/auth/me,
  // later calls (access and profile alike) replay the same cached response.
  // The adminOrg middleware server-side remains the authoritative check on every
  // real API call.
  private me(): Observable<{ code: number; data?: IAdminMe }> {
    if (!this._me$) {
      this._me$ = this._http_service.get<IAdminMe>('admin/auth/me').pipe(
        catchError((error: unknown) =>
          of({ code: error instanceof HttpErrorResponse ? error.status : 0 })
        ),
        shareReplay(1)
      );
    }
    return this._me$;
  }

  access(): Observable<AdminAccess> {
    return this.me().pipe(
      map((response) => {
        if (response.code === 200) {
          return 'admin';
        }
        if (response.code === 403) {
          return 'forbidden';
        }
        return 'signed-out';
      })
    );
  }

  profile(): Observable<{ first_name: string; last_name: string } | null> {
    return this.me().pipe(
      map((response) =>
        response.code === 200 && response.data
          ? { first_name: response.data.first_name, last_name: response.data.last_name }
          : null
      )
    );
  }
}
